import { MARIGOLD, OLAF } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledWrapper = styled.div.withConfig({
  displayName: "HubletBetaLabel__StyledWrapper",
  componentId: "sc-1y6lrsk-0"
})(["text-align:left;font-size:10px;font-weight:700;color:", ";background-color:", ";width:fit-content;padding-left:9px;padding-right:8px;position:absolute;right:-1px;top:0;border-radius:3px;"], OLAF, MARIGOLD);
const HubletBetaLabel = () => {
  return /*#__PURE__*/_jsx(StyledWrapper, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'button.hubletsBeta'
    })
  });
};
export default HubletBetaLabel;